import { render } from "./UpdateUtrForm.vue?vue&type=template&id=dc58cb80&scoped=true"
import script from "./UpdateUtrForm.vue?vue&type=script&lang=js"
export * from "./UpdateUtrForm.vue?vue&type=script&lang=js"

import "./UpdateUtrForm.vue?vue&type=style&index=0&id=dc58cb80&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc58cb80"]])

export default __exports__